const initialState = {
	userName: '',
    isAdmin: false,
	faculty_id: '',
	userProfile: {},
	studentProfile: {}
}

export default (state = initialState, action) => {
    const {type, payload} = action;
    let newState;
	switch (type) {
		case 'SET_LOGIN_INFO':
		case 'UPDATE_PASSWORD':
			newState = {...state, ...payload};
            break;
		case 'USER_LOGOUT':
			newState = {...initialState, faculty_id: state.faculty_id};
			break;
		case 'LOADING':
			newState = {...state, isLoading: payload, apiCalled: !payload};
			break;
		case 'UPDATE_PROFILE':
			newState = {...state, userProfile: payload.newProfile};
			break;
		case 'SET_DEFAULT_PASSWORD':
			newState = {...state, isDefaultPassword: payload.isDefaultPassword};
			break;
		case 'SET_STUDENT_PROFILE':
			newState = {...state, studentProfile: payload.profile, faculty_id: ''};
			break;
		default:
			newState = state;
            break;
	}
    return newState;
}